import { useEffect, useState } from "react";
import { fetchApprovalData, sendApprovalRequest } from "../Api/ExpenseApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";

const ExpenseApproval = () => {
  const [approvals, setApprovals] = useState([]);
  const{user}=useAuth();
  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchApprovalData(user?.organisationId);
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (expenseId) => {
    try {
      await sendApprovalRequest(expenseId);
      toast.success(`🟢 Expense ${expenseId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Expense Approval</span>

          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Expense Type</th>
                      <th>Merchant</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Payment Method</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval.expenseType}</td>
                        <td>{approval.merchantName}</td>
                        <td>{new Date(approval.dateofExpense).toLocaleDateString()}</td>
                        <td>{approval.amountSpent}</td>
                        <td>{approval.currency}</td>
                        <td>{approval.paymentMethod}</td>
                        <td>{approval.descriptionNotes}</td>
                        <td className={approval.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {approval.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                        <td>
                          {approval.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(approval.expenseId)}
                              className="approve-btn"
                            >
                              Approve
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default ExpenseApproval;
